<!-- 修改原因弹窗-->
<template>
	<div style="display: inline;">
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/equipment/fault/standard/page"
			getKey="rows" :columns="columns">
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('guzhangdaima')">
						<el-input v-model="yt.conditions.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('guzhangmingcheng')">
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('guzhangfenlei')">
						<yi_dictionary_select :type="'REASON_DOWNTIME'" :ids.sync="yt.conditions.type">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary"
							plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
					</el-form-item>
					<yi_curd_expand_button></yi_curd_expand_button>
				</el-form>
			</template>
		</yi_curd_table>
	</div>
</template>

<script type="text/javascript">
	export default {
		name: 'web_equipment_shutdown_reason_modification',
		data() {
			return {
				fixConditions: {
					//"billId": this.$attrs.maintainItem.id
				},
				columns: [{
					label: '#',
					type: 'index'
				},{
					label: 'guzhangdaima',
					prop: 'code',
				}, {
					label: 'guzhangmingcheng',
					prop: 'name',

				}, {
					label: 'guzhangfenlei',
					type: 'dictionary',
					key: 'REASON_DOWNTIME',
					prop: 'type',
					width: 150

				}]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
				}
				this.yt.isShowPagination = true
				this.yt.get(1);
			}, 300)
		},
		computed:{
			
		},
		methods: {
			
		}
	};
</script>


<style>
</style>
